import React from "react";
import dayjs from "dayjs";
import { Form } from "antd";
import Button from "@/common/elements/Button";
import CommonDatePicker from "@/common/elements/DatePicker";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import { StyledGridCol, StyledGridRow, StyledSectionHeading } from "@/common/styles";
import { getOptionsFromRefList } from "@/util/common_function";
import useDialog from "@/hooks/useDialog";

const JailIncidentInvolvedReportInformation = ({ data, onValuesChange, disabled }) => {
  const { showDialog } = useDialog();

  const combineDateTime = (date, time) => {
    return date && time ? dayjs(`${date} ${time}`, "MM/DD/YYYY HH:mm") : null;
  };

  const initialValues = {
    involvementType: data?.jailIncidentsInvolvementType || "",
    disciplineRequired: data?.disciplineRequired?.trim() || "",
    startDateTime: combineDateTime(data?.hearingStartDate, data?.hearingStartTime),
    hearingDueDateTime: combineDateTime(data?.hearingDueDate, data?.hearingDueTime),
    hearingDateTime: combineDateTime(data?.hearingDate, data?.hearingTime),
    hearingOfficer: data.hearingOfficerStaffID || "",
    reviewOfficer: data?.reviewOfficerStaffID || "",
    results: data?.jailIncidentsResults || "",
    comments: data?.hearingComments || "",
  };

  const onHandleViewComment = () => {
    const comment = data?.hearingComments || "No comment available";
    showDialog("info", {
      content: comment,
      confirmButtonText: "Ok",
    });
  };

  return (
    <>
      <StyledSectionHeading marginTop="20px">
        <span>Report Information</span>
      </StyledSectionHeading>
      
      <Form
        name="jailIncidentInvolvedReportInformation"
        initialValues={initialValues}
        onValuesChange={onValuesChange}
      >
        <StyledGridRow gutter={16}>
          <StyledGridCol lg={6}>
            <FormItem label="Involvement Type" name="involvementType">
              <Select
                disabled={disabled}
                options={getOptionsFromRefList("JailIncidentsInvolvementType", false, false, true)}
              />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol lg={6}>
            <FormItem label="Action Taken" name="disciplineRequired">
              <Select
                disabled={disabled}
                options={getOptionsFromRefList("Discipline_Required")}
              />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>

        <StyledGridRow gutter={16}>
          <StyledGridCol lg={7}>
            <FormItem label="Start Date/Time" name="startDateTime">
              <CommonDatePicker 
                showTime={true} 
                format="MM/DD/YYYY HH:mm" 
                disabled={disabled}
              />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol lg={7}>
            <FormItem label="Hearing Due Date/Time" name="hearingDueDateTime">
              <CommonDatePicker 
                showTime={true} 
                format="MM/DD/YYYY HH:mm" 
                disabled={disabled}
              />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>

        <StyledGridRow gutter={16}>
          <StyledGridCol lg={7}>
            <FormItem label="Hearing Date/Time" name="hearingDateTime">
              <CommonDatePicker 
                showTime={true} 
                format="MM/DD/YYYY HH:mm" 
                disabled={disabled}
              />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol lg={6}>
            <FormItem label="Hearing Officer" name="hearingOfficer">
              <Select
                disabled={disabled}
                options={getOptionsFromRefList("", true, false, true)}
              />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol lg={6}>
            <FormItem label="Review Officer" name="reviewOfficer">
              <Select
                disabled={disabled}
                options={getOptionsFromRefList("", true, false, true)}
              />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol lg={5}>
            <FormItem label="Results" name="results">
              <Select
                disabled={disabled}
                options={getOptionsFromRefList("JailIncidentsResults", false, false, true)}
              />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol xs={24} lg={24}>
            <FormItem label="Comments" name="comments">
              <TextField 
                inputType="textarea" 
                rows="3" 
                disabled={disabled}
              />
            </FormItem>
            <Button 
              type="secondary" 
              color="secondary" 
              onClick={onHandleViewComment}
            >
              View Comments
            </Button>
          </StyledGridCol>
        </StyledGridRow>
      </Form>
    </>
  );
};

export default JailIncidentInvolvedReportInformation;
